import React, { useState, useEffect } from "react";
import "./styles.css";

const ThirdQuestionFormComponent = ({
  questionResponse,
  questions,
  onChangeQuestions,
  setShowErrorModal,
}) => {
  const [showInput1, setShowInput1] = useState(false);
  const [showInput2, setShowInput2] = useState(false);
  const [showInput3, setShowInput3] = useState(false);

  useEffect(() => {
    if (questions.q3.response === true) {
      setShowInput1(true);
    }
    if (questions.q4.response === true) {
      setShowInput2(true);
    }
    if (questions.q5.response === true) {
      setShowInput3(true);
    }
  }, []);

  const onClickNext = () => {
    if (
      ((questions.q3.response === true && questions.q3.observations !== "") ||
        (questions.q3.response === false &&
          questions.q3.observations === "")) &&
      ((questions.q4.response === true && questions.q4.observations !== "") ||
        (questions.q4.response === false &&
          questions.q4.observations === "")) &&
      ((questions.q5.response === true && questions.q5.observations !== "") ||
        (questions.q5.response === false && questions.q5.observations === ""))
    ) {
      questionResponse(4);
    } else {
      setShowErrorModal(true);
    }
  };

  const onClickRadio = (event) => {
    const id = event.target.id;
    let observations = "";
    let question;

    if (id === "optionYes1") {
      setShowInput1(true);
      question = "q3";
      saveDataQuestion(id, observations, question);
    } else if (id === "optionNo1") {
      setShowInput1(false);
      question = "q3";
      saveDataQuestion(id, "", question);
    } else if (id === "optionYes1Input") {
      observations = event.target.value;
      question = "q3";
      saveDataQuestion(id, observations, question);
    }

    if (id === "optionYes2") {
      setShowInput2(true);
      question = "q4";
      saveDataQuestion(id, observations, question);
    } else if (id === "optionNo2") {
      setShowInput2(false);
      question = "q4";
      saveDataQuestion(id, "", question);
    } else if (id === "optionYes2Input") {
      observations = event.target.value;
      question = "q4";
      saveDataQuestion(id, observations, question);
    }

    if (id === "optionYes3") {
      setShowInput3(true);
      question = "q5";
      saveDataQuestion(id, observations, question);
    } else if (id === "optionNo3") {
      setShowInput3(false);
      question = "q5";
      saveDataQuestion(id, "", question);
    } else if (id === "optionYes3Input") {
      observations = event.target.value;
      question = "q5";
      saveDataQuestion(id, observations, question);
    }
  };

  const saveDataQuestion = (id, observations, question) => {
    let valueQuestion;
    if (
      id === "optionYes1" ||
      id === "optionYes2" ||
      id === "optionYes3" ||
      id === "optionYes1Input" ||
      id === "optionYes2Input" ||
      id === "optionYes3Input"
    ) {
      valueQuestion = true;
    } else if (id === "optionNo1" || id === "optionNo2" || id === "optionNo3") {
      valueQuestion = false;
    }
    const updatedQuestions = {
      ...questions,
      [question]: { response: valueQuestion, observations: observations },
    };
    onChangeQuestions(updatedQuestions, question);
  };

  return (
    <div className="thirdQuestionFormComponent">
      <div className="contentQuestionFormComponent">
        <p className="questionTitleFormComponent">¿Padece alguna enfermedad?</p>
        <div className="contentRadioButtonsFormComponent">
          <label htmlFor="optionNo1">
            <input
              type="radio"
              id="optionNo1"
              name="question1"
              defaultChecked={questions.q3.response === false}
              onChange={(event) => onClickRadio(event)}
            />
            No
          </label>
          <label htmlFor="optionYes1">
            <input
              type="radio"
              id="optionYes1"
              name="question1"
              defaultChecked={questions.q3.response === true}
              onChange={(event) => onClickRadio(event)}
            />
            Si
          </label>
        </div>
        <div className="contentInputFormComponent">
          <input
            type="text"
            id="optionYes1Input"
            className={`${showInput1 ? "showInput" : "inputQuestions"}`}
            placeholder="Especifique..."
            value={questions.q3.observations}
            onChange={(event) => onClickRadio(event)}
          />
        </div>
      </div>
      <div className="contentQuestionFormComponent">
        <p className="questionTitleFormComponent">
          ¿Es alérgico/a a algún medicamento?
        </p>
        <div className="contentRadioButtonsFormComponent">
          <label htmlFor="optionNo2">
            <input
              type="radio"
              id="optionNo2"
              name="question2"
              defaultChecked={questions.q4.response === false}
              onChange={(event) => onClickRadio(event)}
            />
            No
          </label>
          <label htmlFor="optionYes2">
            <input
              type="radio"
              id="optionYes2"
              name="question2"
              defaultChecked={questions.q4.response === true}
              onChange={(event) => onClickRadio(event)}
            />
            Si
          </label>
        </div>
        <div className="contentInputFormComponent">
          <input
            type="text"
            id="optionYes2Input"
            className={`${showInput2 ? "showInput" : "inputQuestions"}`}
            placeholder="Especifique..."
            value={questions.q4.observations}
            onChange={(event) => onClickRadio(event)}
          />
        </div>
      </div>
      <div className="contentQuestionFormComponent">
        <p className="questionTitleFormComponent">
          ¿Toma a diario algún medicamento?
        </p>
        <div className="contentRadioButtonsFormComponent">
          <label htmlFor="optionNo3">
            <input
              type="radio"
              id="optionNo3"
              name="question3"
              defaultChecked={questions.q5.response === false}
              onChange={(event) => onClickRadio(event)}
            />
            No
          </label>
          <label htmlFor="optionYes3">
            <input
              type="radio"
              id="optionYes3"
              name="question3"
              defaultChecked={questions.q5.varesponselue === true}
              onChange={(event) => onClickRadio(event)}
            />
            Si
          </label>
        </div>
        <div className="contentInputFormComponent">
          <input
            type="text"
            id="optionYes3Input"
            className={`${showInput3 ? "showInput" : "inputQuestions"}`}
            placeholder="Especifique..."
            value={questions.q5.observations}
            onChange={(event) => onClickRadio(event)}
          />
        </div>
      </div>
      <button className="btnForm" onClick={onClickNext}>
        Siguiente
      </button>
    </div>
  );
};

export default ThirdQuestionFormComponent;
